module.exports = __webpack_public_path__ + "static/alphapark-2d497e5ce79ff408d442c245b7a49bc9.jpg";